let parser = null
export const stripHtml = (text: string, useParser = false) => {
  if (useParser) {
    if (!parser) {
      parser = new DOMParser()
    }

    try {
      const parsed = parser.parseFromString(text, 'text/html')

      return parsed.body.firstChild.textContent
    } catch {
      return text
    }
  }
  if (!text) {
    return ''
  }
  return text.replace(/(<([^>]+)>)/gi, '')
}
